import { type ComponentProps } from 'react';

import { type FormatDateOptions } from 'react-intl';

import BookOpenIcon from '@atlaskit/icon-lab/core/book-open';
import { IconTile } from '@atlaskit/icon-next';

import { type ArticleAccentColor } from '../../jsm-portal-playground-data';

export const BRAND_FONT = '"Work Sans", "Atlassian Sans", sans-serif';

export const BEACON_GRADIENT = 'linear-gradient(90deg, #E1EF8F 0%, #94E7D6 100%)';

export const CARD_DATE_FORMAT: FormatDateOptions = {
	day: 'numeric',
	month: 'long',
	year: 'numeric',
	timeZone: 'UTC',
};

export const ARTICLE_DATE_FORMAT: FormatDateOptions = {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric',
	timeZone: 'UTC',
};

type IconTileIcon = ComponentProps<typeof IconTile>['icon'];

const BookTileIcon = BookOpenIcon as unknown as IconTileIcon;

export const PortalArticleIconTile = ({
	color,
	size,
}: {
	color: ArticleAccentColor;
	size: 'medium' | 'xlarge';
}) => (
	<IconTile
		icon={BookTileIcon}
		label=""
		appearance={color === 'teal' ? 'tealBold' : 'limeBold'}
		size={size}
	/>
);
